/**
 * 菜单栏过滤，一级转二级菜单
 */
export function filterMenu(list) {
    let menu = [];

    // 找出第一级
    let firstMenu = {};
    list.forEach((l) => {
        if (l.pid === 0) {
            firstMenu[l.id] = l;
        }
    });

    // 找出第二级菜单
    list.forEach((l) => {
        if (firstMenu[l.pid]) {
            if (!firstMenu[l.pid].children) firstMenu[l.pid].children = [];
            firstMenu[l.pid].children.push(l);
        }
    });

    for (let k in firstMenu) {
        menu.push(firstMenu[k]);
    }

    return menu;
}

/**
 * 时间格式处理函数
 * @param  {[type]} date [description]
 * @param  {[type]} fmt  [description]
 * @return {[type]}      [description]
 */
export const formatDate = (date, fmt = 'YYYY-mm-dd HH:MM:SS') => {
    // YYYY-mm-dd HH:MM:SS
    if (!date) {
        return '';
    }
    if (
        Object.prototype.toString.call(date) == '[object String]' &&
        date.match('-')
    ) {
        date = date.replace(/\-/g, '/');
    }
    let ret;
    date = new Date(date);
    const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (const k in opt) {
        ret = new RegExp(`(${k})`).exec(fmt);
        if (ret) {
            fmt = fmt.replace(
                ret[1],
                ret[1].length == 1 ? opt[k] : padZero(opt[k], ret[1].length)
            );
        }
    }
    return fmt;
};

const padZero = (target, length) => {
    const t_length = target.length;
    if (t_length === length) {
        return target;
    }
    const temp = '0000000000';
    if (t_length < length) {
        return `${temp.substr(0, length - t_length)}${target}`;
    }
    return target;
};

// 防抖
export const throttle = function (fn, gapTime) {
    if (gapTime == null || gapTime == undefined) {
        gapTime = 1000;
    }

    let _lastTime = null;
    // 返回新的函数
    return function (e) {
        const _nowTime = +new Date();
        if (_nowTime - _lastTime > gapTime || !_lastTime) {
            fn.apply(this, arguments); //将this和参数传给原函数
            // fn(this, e); // 上方法不可行的解决办法 改变this和e
            _lastTime = _nowTime;
        }
    };
};

// 获取当前时间，前n天的日期
const oneDayTime = 1000 * 60 * 60 * 24;
export const getPrevDay = function (n) {
    const nowTime = new Date().getTime();

    return formatDate(nowTime - oneDayTime * n, 'YYYY-mm-dd');
};

/**
 * 解析的url列表
 * urlType:
 *0->URL
 *1->告警URL
 *2->安全URL
 *
 */
export const parseUrlList = (urlsList, urlType) => {
    var stringBuilder = [];
    urlsList.forEach((urls, index) => {
        if (urlType === 1) {
            //告警URL
            if (urls['YaraRuleNames'].length <= 0) {
                return true;
            }
        } else if (urlType === 2) {
            //安全URL
            if (urls['YaraRuleNames'].length > 0) {
                return true;
            }
        }
        stringBuilder[index] = urls['Url'];
    });
    return stringBuilder.join('；\n');
};

/**
 * 深拷贝
 */
export const deepClone = (data) => {
    var t = checkType(data),
        o,
        i,
        ni;

    if (t === 'array') {
        o = [];
    } else if (t === 'object') {
        o = {};
    } else {
        return data;
    }

    if (t === 'array') {
        for (i = 0, ni = data.length; i < ni; i++) {
            o.push(deepClone(data[i]));
        }
        return o;
    } else if (t === 'object') {
        for (i in data) {
            o[i] = deepClone(data[i]);
        }
        return o;
    }
};

function checkType(obj) {
    var toString = Object.prototype.toString;
    var map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
    };
    return map[toString.call(obj)];
}

// 换算文件大小
export const formatFileSize = (fileSize) => {
    var temp
    if (fileSize < 1024) {
        return fileSize + 'B';
    } else if (fileSize < 1024 * 1024) {
        temp = fileSize / 1024;
        temp = temp.toFixed(2);
        return temp + 'KB';
    } else if (fileSize < 1024 * 1024 * 1024) {
        temp = fileSize / (1024 * 1024);
        temp = temp.toFixed(2);
        return temp + 'MB';
    } else {
        temp = fileSize / (1024 * 1024 * 1024);
        temp = temp.toFixed(2);
        return temp + 'GB';
    }
};

export const handlerParams = (url, params) => {
    if (Object.prototype.toString.call(params) !== '[object Object]') {
        return url;
    }
    let result = '';
    for (let key in params) {
        result += `${key}=${params[key]}&`
    }
    return url + has(url) + result.substring(0, result.length - 1);

    function has(s) {
        return s.indexOf('?') !== -1 ? '&' : '?'
    }
};

export const isArray = (arr) => {
    return Object.prototype.toString.call(arr) === '[object Array]'
}